module.exports = __webpack_public_path__ + "static/feature2-d8bff741fe8083d7a1c00194cac4af61.png";